import { render, staticRenderFns } from "./creatPrintreceipt.vue?vue&type=template&id=6ce8171c&scoped=true"
import script from "./creatPrintreceipt.vue?vue&type=script&lang=js"
export * from "./creatPrintreceipt.vue?vue&type=script&lang=js"
import style0 from "./creatPrintreceipt.vue?vue&type=style&index=0&id=6ce8171c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce8171c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce8171c')) {
      api.createRecord('6ce8171c', component.options)
    } else {
      api.reload('6ce8171c', component.options)
    }
    module.hot.accept("./creatPrintreceipt.vue?vue&type=template&id=6ce8171c&scoped=true", function () {
      api.rerender('6ce8171c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/printing/printReceipt/creatPrintreceipt.vue"
export default component.exports